module.exports = __webpack_public_path__ + "static/media/Fonepay.7b23e77d.png";